import { debounce } from 'lodash';
import validationMessage from '../assets/validationMessages.json';

const touchMap = new WeakMap();

export default {
  data: () => ({
    validationMessage,
  }),
  methods: {
    touchInput($v) {
      $v.$touch();
    },
    invokeTouch($v) {
      $v.$reset();
      $v.$touch();
      this.emitStep();
    },
    delayTouchCounterComposition($v, name, value) {
      $v = $v[name];
      $v.$model = value;
      this.delayTouch($v);
    }
    ,
    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout(() => {
        this.touchInput($v);
      }, 300));
      this.emitStep();
    },
    // eslint-disable-next-line
    emitStep: debounce(function () {
      this.$emit('step-data', this.form);
      this.$emit('is-valid', !this.$v.$invalid);
    }, 300),
    log(e) {
      console.log(e);
    },
  },
};
